import { Chain } from 'viem/chains'
const mainnet_config: Chain = {
    id: 137,
    name: 'Polygon',
    nativeCurrency: {
        name: 'MATIC',
        symbol: 'MATIC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://polygon-mainnet.infura.io/v3/9cfcd8bccc5a482bb84b034e63d907e5'],
        },
        public: {
            http: ['https://polygon-mainnet.infura.io/v3/9cfcd8bccc5a482bb84b034e63d907e5'],
        },
    },
    blockExplorers: {
        default: { name: 'Polygonscan', url: 'https://polygonscan.com' },
    },
    testnet: false,
}

const test_net_config: Chain = {
    id: 80002,
    name: 'Polygon Amoy',
    nativeCurrency: {
        name: 'MATIC',
        symbol: 'MATIC',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: ['https://polygon-amoy.infura.io/v3/9cfcd8bccc5a482bb84b034e63d907e5']
        },
        public: {
            http: ['https://polygon-amoy.infura.io/v3/9cfcd8bccc5a482bb84b034e63d907e5'],
        },
    },
    blockExplorers: {
        default: { name: 'PolygonScan Amoy', url: 'https://amoy.polygonscan.com' }
    },
    testnet: true
}

export { mainnet_config, test_net_config }
